import classNames from 'classnames'
import type {ComponentProps} from 'react'
import * as S from './styles'
import C from './styles.module.css'

interface HeadlineProps extends ComponentProps<'div'> {
  as?: any
}

const _Headline = ({as = 'div', ...props}: HeadlineProps) => {
  const AsComponent = as as 'div'
  return (
    <AsComponent
      {...props}
      className={classNames(C.wrapper, props.className)}
    />
  )
}

export const Headline = Object.assign(_Headline, {
  Cover: S.Cover,
  Body: S.Body,
  Heading: S.Heading,
})
